import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { EfactoryPubSubService } from '@ats/service-pubsub';
import { EfpServiceUserNotificationModule } from '@ats/service-user-notification';
import { AuthModule } from '@auth0/auth0-angular';
import { TranslocoModule } from '@ngneat/transloco';
import { MastheadDrawerComponent } from './masthead-drawer/masthead-drawer.component';
import { MastheadUserComponent } from './masthead-user/masthead-user.component';

@NgModule({
  declarations: [MastheadUserComponent, MastheadDrawerComponent],
  imports: [
    CommonModule,
    FormsModule,
    FlexLayoutModule,
    MatButtonModule,
    MatMenuModule,
    MatSlideToggleModule,
    OverlayModule,
    TranslocoModule,
    EfpServiceUserNotificationModule,
    AuthModule
  ],
  providers: [EfactoryPubSubService],
  exports: [MastheadUserComponent, MastheadDrawerComponent]
})
export class MastheadModule {}
